import NavBar from "./components/NavBar";
import React from "react";
import PrivacyPolicy from "./components/PrivacyPolicy";

function App() {
  return (
    <div className="flex flex-col  bg-indigo-900">
      <NavBar />
      <PrivacyPolicy />
    </div>
  );
}

export default App;
